import styled from "styled-components";

export const TooltipWrapper = styled.div`
    white-space: normal;
    padding: 5px;
`;
